import React, { Component } from 'react';
import Layout  from './components/Layout';
import Home from './components/Home';
import Login from './components/Login';
import MonarchCCAA from './components/MonarchCCAA';
import ProvideAuth from './components/admin/ProvideAuth';
import Confirmation from './components/Confirmation';
import AdminLogin from './components/admin/AdminLogin';
import AdminHome from './components/admin/AdminHome';
import { useEffect } from 'react';

import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

function App(){

  useEffect(() => {
    const handleTabClose = event => {
      event.preventDefault();
      return (event.returnValue =
        'Please save your responses');
    };

    window.addEventListener('beforeunload', handleTabClose);

    return () => {
      window.removeEventListener('beforeunload', handleTabClose);
    };
  }, []);


  return (
    <Layout>
     <Routes>
          <Route exact path="/" element={<Login />} />
          <Route path="/Home" element={
              <Home />
          } />
          <Route exact path="/Home" element={
            <Home />
          } />
          <Route exact path="/Admin" element={
              <AdminLogin />
          } />
          <Route exact path="/AdminHome" element={
              <AdminHome />
          } />
          <Route exact path="/MonarchCCAA" element={
              <MonarchCCAA />
          } />
          <Route exact path="/Confirmation" element={
              <Confirmation />
          } />
          <Route path="*" element={<Login />} />
      </Routes>
    </Layout>

  );

}

export {Router};

export default App;
